import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';
import { locale } from 'src/utils/settings';
import { makeZodErrorMap } from 'src/utils/zodErrorMap';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: locale || 'vi',
    debug: false,
    ns: ['translation', 'pos', 'dashboard', 'authentication'],
    interpolation: {
      escapeValue: false,
    },
  })
  .then((r) => r);

/**
 * Zod's own messages are English and no schema localises them on its own. Setting the map
 * here — once, globally — covers every schema in the app; it reads through `i18n.t` at
 * validation time, so it follows a language change without being re-registered.
 */
z.setErrorMap(makeZodErrorMap((key, options) => i18n.t(key, options)));

export default i18n;
